import { inheritSource } from './inheritSource';
import { shortLinkSource } from './shortLinkSource';
import { urlParamsSource } from './urlParamsSource';

export { urlParamsSource } from './urlParamsSource';
export { shortLinkSource } from './shortLinkSource';
export { inheritSource } from './inheritSource';
export { createLegacyUrlParamsSource } from './createLegacyUrlParamsSource';

/**
 * 获取内置初始化来源列表。
 */
export const getDefaultSources = () => {
  return [urlParamsSource, shortLinkSource, inheritSource];
};
